class RoBackInStockNotificationForm extends HTMLElement {
  constructor() {
    super();

    this.notifyForm = this.querySelector('form');
    this.email = this.querySelector('[id^="back-in-stock-notification-form-email-"]');
    this.notifyBtn = this.querySelector('[id^="back-in-stock-notification-form-submit-"]');

    this.productForm = document.querySelector('.ro-product-form');

    this.addEvents();
    //this.validateEmail();
  }

  addEvents() {
    this.notifyForm.addEventListener('submit', function (event) {
      event.preventDefault();
      this.buildData();
    }.bind(this));
  }

  async buildData() {
    try {
      if (typeof this.dataset.klaviyoPublicApiKey === 'undefined') {
        throw new Error('Klaviyo public API key is missing');
      }

      if (typeof this.dataset.variantId === 'undefined') {
        throw new Error('Variant ID is missing');
      }

      if (typeof this.dataset.default === 'undefined') {
        throw new Error('Default text is missing');
      }

      if (typeof this.dataset.success === 'undefined') {
        throw new Error('Success text is missing');
      }

      if (typeof this.dataset.error === 'undefined') {
        throw new Error('Error text is missing');
      }

      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": this.email.value,
                }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": "$shopify:::$default:::" + this.dataset.variantId
              }
            }
          }
        }
      };

      const responseData = await fetch(
        "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + this.dataset.klaviyoPublicApiKey,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "revision": "2024-06-15"
          },
          body: JSON.stringify(payload),
        }
      );

      if (responseData.ok) {
        this.notifyForm.reset();
        this.notifyBtn.innerText = this.dataset.success;
      } else {
        console.error("Error while subscribing", responseData.errors);
        this.notifyBtn.innerText = this.dataset.error;
      }

      setTimeout(() => {
        this.notifyBtn.innerText = this.dataset.default;
      }, 3000);
    } catch (error) {
      console.error("Exception while subscribing", error);
    }
  }

  update(variant) {
    if (variant.available) {
      this.classList.add('tw-hidden');
      this.productForm?.classList.remove('tw-hidden');
    } else {
      this.dataset.variantId = variant.id;
      this.classList.remove('tw-hidden');
      this.productForm?.classList.add('tw-hidden');
    }
  }
}

customElements.define('ro-back-in-stock-notification-form', RoBackInStockNotificationForm);